<mat-card
    class="daxa-card recent-orders-card  border-radius bg-white border-none d-block p-3"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-none outline-0 rounded-pill"
                       placeholder="Chercher un devis..." (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <mat-card-subtitle>

        <!-- <button class="btn btn-primary btn-sm me-3 rounded-pill border-0"
        (click)="generateDevis()">
  
            @if (loadingOT) {
                    <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                    <span class="px-2">Chargement</span>
                } @else {
                    <span class="px-2">Devis</span>
                }
            </button>--> 
            <button class="btn btn-primary btn-sm rounded-pill shadow-sm" (click)="openModal(content)">
              <span class="px-2">Nouveau</span>
            </button>
            <button class="btn btn-outline-primary btn-sm rounded-pill border-0" [matMenuTriggerFor]="menu"
                    aria-haspopup="true" aria-expanded="false" id="dropdownMenuClickableInside">
                <i class="fa-solid fa-arrow-down-short-wide px-3"></i>
            </button>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">
            <div class="table-responsive">
              <div *ngIf="pdfPreviewUrl; else tableView" class="mt-4">
                <h3>Aperçu du devis</h3>
                <button mat-button (click)="closePdfPreview()">
                  <i class="fa-solid fa-arrow-left"></i>
                </button>
              <button 
                *ngIf="devisPreviewId !== null" 
                (click)="creerBonCommandeDepuisDevis(devisPreviewId)"
                class="px-6 py-2 rounded-2xl text-white font-semibold shadow-md hover:bg-primary/90 transition duration-200 mb-4" style="border: none;border-radius: 5px;background-color: rgb(137, 137, 247);">
                <i class="fas fa-file-signature mr-2"></i>
                Transformer en Bon de Commande
              </button>

               <iframe [src]="pdfPreviewUrl | safe" width="100%" height="800px" frameborder="0"></iframe>
              </div>
              <ng-template #tableView>
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

                  <!-- select Column -->
                  <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                      <mat-checkbox (change)="handleSelectAll()" [checked]="isAllRapportSelected"/>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <mat-checkbox [checked]="isAllRapportSelected" (change)="handleSelection(element)"/>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="numeroDevis">
                    <th mat-header-cell *matHeaderCellDef> Référence </th>
                    <td mat-cell *matCellDef="let element"
                        (click)="element.status === 'ACCEPTE' ? generateDevisPreview([element.id]) : null"
                        [ngStyle]="{
                          cursor: element.status === 'ACCEPTE' ? 'pointer' : 'default',
                          color: element.status === 'ACCEPTE' ? '#1976d2' : 'inherit',
                          textDecoration: element.status === 'ACCEPTE' ? 'underline' : 'none'
                        }">
                      {{ element.numeroDevis }}
                    </td>
                  </ng-container>
                                      
                  <!-- Date de création -->
                  <ng-container matColumnDef="dateCreation">
                    <th mat-header-cell *matHeaderCellDef> Date de création </th>
                    <td mat-cell *matCellDef="let element"> {{ element.dateCreation | date }} </td>
                  </ng-container>
                
                  <!-- Date d'expiration -->
                  <ng-container matColumnDef="dateExpiration">
                    <th mat-header-cell *matHeaderCellDef> Date d'expiration </th>
                    <td mat-cell *matCellDef="let element"> {{ element.dateExpiration | date }} </td>
                  </ng-container>
                
                  <!-- Date de livraison -->
                  <ng-container matColumnDef="dateLivraison">
                    <th mat-header-cell *matHeaderCellDef> Date de livraison </th>
                    <td mat-cell *matCellDef="let element"> {{ element.dateLivraison | date }} </td>
                  </ng-container>
                
                  <!-- Délai de livraison -->
                  <ng-container matColumnDef="delaiLivraison">
                    <th mat-header-cell *matHeaderCellDef> Délai livraison </th>
                    <td mat-cell *matCellDef="let element"> {{ element.delaiLivraison }} jours</td>
                  </ng-container>
                
                  <!-- Méthode d'expédition -->
                  <ng-container matColumnDef="methodeExpedition">
                    <th mat-header-cell *matHeaderCellDef> Méthode expédition </th>
                    <td mat-cell *matCellDef="let element"> {{ element.methodeExpedition }} </td>
                  </ng-container>
                
                  <!-- Condition de règlement -->
                  <ng-container matColumnDef="conditionReglement">
                    <th mat-header-cell *matHeaderCellDef> Condition de règlement </th>
                    <td mat-cell *matCellDef="let element"> {{ element.conditionReglement }} </td>
                  </ng-container>
                
                  <!-- Total HT -->
                  <ng-container matColumnDef="totalHT">
                    <th mat-header-cell *matHeaderCellDef> Total HT </th>
                    <td mat-cell *matCellDef="let element"> {{ element.totalHT | number:'1.2-2' }} MAD</td>
                  </ng-container>
                
                  <!-- Total TTC -->
                  <ng-container matColumnDef="totalTTC">
                    <th mat-header-cell *matHeaderCellDef> Total TTC </th>
                    <td mat-cell *matCellDef="let element"> {{ element.totalTTC | number:'1.2-2' }} MAD</td>
                  </ng-container>
                
                  <!-- Client 
                  <ng-container matColumnDef="clientNom">
                    <th mat-header-cell *matHeaderCellDef> Client </th>
                    <td mat-cell *matCellDef="let element"> {{ element.clientNom }} </td>
                  </ng-container>-->
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef> Statut </th>
                    <td mat-cell *matCellDef="let element"> {{ element.status }} </td>
                  </ng-container>
                  <ng-container matColumnDef="validite">
                    <th mat-header-cell *matHeaderCellDef> validite </th>
                    <td mat-cell *matCellDef="let element"> {{ element.validite }} </td>
                  </ng-container>
                
                  <!-- Type d'analyse -->
    <!-- Type d'analyse -->
    <ng-container matColumnDef="typeAnalyseNom">
      <th mat-header-cell *matHeaderCellDef> Type d'analyse </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngFor="let detail of element.details">
          {{ detail.typeAnalyseNom }} <br />
        </ng-container>
      </td>
    </ng-container>
  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef class="text-center"> Actions</th>
    <td mat-cell *matCellDef="let element">
        <div class="action-info text-center" style="justify-content: center !important;">
          <button type="button" mat-button matTooltip="Télécharger PDF" matTooltipPosition="above" 
          (click)="generateDevis(element.id)">
          <i class="fa-solid fa-file-pdf text-success"></i>

      </button>
      

        
            <button type="button" mat-button matTooltip="Modifier" matTooltipPosition="above"
                    (click)="openEditModal(element,editModal)">
                <i class="material-symbols-outlined text-primary">
                    brush
                </i>
            </button>
            <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above"
                    (click)="confirmDelete(element)">
                <i class="material-symbols-outlined text-danger">
                    delete
                </i>
            </button>
            <button *ngIf="element.status === 'ACCEPTE'" 
            type="button" 
            mat-button 
            matTooltip="Créer bon de commande" 
            matTooltipPosition="above"
            (click)="creerBonCommandeDepuisDevis(element.id)">
      <i class="material-symbols-outlined">receipt_long</i>
    </button>
    
        </div>
    </td>
  </ng-container>

                
                  <!-- Table Header and Rows -->
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                
                </table>
             </ng-template>
                <div *ngIf="loadingTable">
                    <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                        <span class="skeleton-cell"></span>
                    </div>
                </div>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

        </div>

    </mat-card-content>
</mat-card>

<ng-template #content let-modal>
  <mat-card class="daxa-card border-radius bg-white border-none d-block">
    <mat-card-header>
        <mat-card-title>
          <h5 class="mt-0 mb-0">Nouvelle proposition de devis</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form [formGroup]="Form" (ngSubmit)="saveDevis()">
          <div class="row g-3">
            <div class="col-sm-6">
              <mat-form-field class="full-width">
                <mat-label>Client</mat-label>
                <mat-select formControlName="clientId">
                  <mat-option *ngFor="let client of clients" [value]="client.id">
                    {{ client.socialReason }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="Form.get('clientId')?.hasError('required')">Le client est requis</mat-error>
              </mat-form-field>
            </div>
        
            <div class="col-sm-6" *ngFor="let field of ['dateExpiration', 'dateLivraison']">
              <mat-form-field class="full-width">
                <mat-label>
                  {{ 
                     field === 'dateExpiration' ? 'Date d\'expiration' : 
                     field === 'dateLivraison' ? 'Date de livraison' : field }}
                </mat-label>
                <input matInput type="date" [formControlName]="field">
                <mat-error *ngIf="Form.get(field)?.hasError('required')">Ce champ est requis</mat-error>
              </mat-form-field>
            </div>
        
            <div class="col-sm-6" [ngStyle]="{ display: 'none' }">
              <mat-form-field class="full-width">
                <mat-label>Statut</mat-label>
                <mat-select formControlName="status" placeholder="Sélectionnez un statut">
                  <mat-option *ngFor="let statut of statutsDevis" [value]="statut">
                    {{ statut }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="Form.get('status')?.hasError('required')">Le statut est requis</mat-error>
              </mat-form-field>
            </div>
        
            <div class="col-sm-6">
              <mat-form-field class="full-width">
                <mat-label>Délai de livraison après commande</mat-label>
                <input matInput type="number" formControlName="delaiLivraison" min="1">
                <mat-error *ngIf="Form.get('delaiLivraison')?.hasError('required')">Ce champ est requis</mat-error>
              </mat-form-field>
            </div>
        
            <div class="col-sm-6" *ngFor="let field of ['methodeExpedition', 'conditionReglement']">
              <mat-form-field class="full-width">
                <mat-label>{{ field === 'methodeExpedition' ? 'Méthode d\'expédition' : 'Condition de règlement' }}</mat-label>
                <textarea matInput [formControlName]="field" rows="4"></textarea>
                <mat-error *ngIf="Form.get(field)?.hasError('required')">Ce champ est requis</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field class="full-width">
                <mat-label>Durée de validité</mat-label>
                <input matInput formControlName="validite" placeholder="Ex. 30 jours">
                <mat-error *ngIf="Form.get('validite')?.hasError('required')">La durée de validité est requise</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-checkbox style="margin-left: 10px;margin-top: 5px;"
                [checked]="!Form.get('tvaApplicable')?.value"
                (change)="Form.get('tvaApplicable')?.setValue(!Form.get('tvaApplicable')?.value)">
                TVA Non Applicable  
              </mat-checkbox>
            </div>
            <div [formGroup]="detailForm" class="row g-3">
              <div class="d-flex align-items-center g-3">
                <div class="col-sm-4">
                  <mat-form-field class="full-width">
                    <mat-label>Type d'Analyse</mat-label>
                    <mat-select formControlName="typeAnalyseId" (selectionChange)="onTypeAnalyseChangex()">
                      <mat-option *ngFor="let typeAnalyse of typeAnalyses" [value]="typeAnalyse.id">
                        {{ typeAnalyse.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="detailForm.get('typeAnalyseId')?.hasError('required')">Requis</mat-error>
                  </mat-form-field>
                </div>
              
                <div class="col-sm-4 ms-3">
                  <mat-form-field class="full-width">
                    <mat-label>Quantité</mat-label>
                    <input matInput type="number" formControlName="qte" min="1">
                    <mat-error *ngIf="detailForm.get('qte')?.hasError('required')">Requis</mat-error>
                  </mat-form-field>
                </div>
              
                <div class="col-sm-3 ms-3">
                  <mat-form-field class="full-width">
                    <mat-label>Prix Unitaire</mat-label>
                    <input matInput type="number" formControlName="prixUnitaire" readonly>
                    <mat-error *ngIf="detailForm.get('prixUnitaire')?.hasError('required')">Requis</mat-error>
                  </mat-form-field>
                </div>
              
                <div class="col-sm-1 d-flex align-items-center ms-1" >
                  <button type="button" mat-button matTooltip="Ajouter" matTooltipPosition="above"
                  (click)="addDetailx()" >
                  <i class="material-symbols-outlined text-primary" style="font-size: 30px;">
                    add
                  </i>
          </button>
                </div>
                
                
              </div>
            </div>
            <table class="table table-striped table-bordered mt-4" *ngIf="detailsList.length > 0">
              <thead class="table-light">
                <tr>
                  <th>Type d'Analyse</th>
                  <th>Méthode</th>
                  <th>Délai</th>
                  <th>Prix Unitaire</th>
                  <th>Quantité</th>
                  <th><strong>Total</strong></th> 
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let d of detailsList; let i = index">
                  <td>{{ getTypeAnalyseName(d.typeAnalyseId) }}</td>
                  <td>{{ getTypeAnalyseDesc(d.typeAnalyseId) }}</td>
                  <td>{{ getTypeAnalyseDelai(d.typeAnalyseId) }}j</td>
                  <td>{{ d.prixUnitaire }}</td>
                  <td>{{ d.qte }}</td>
                  <td>{{ d.total }}</td>

                  <td>
                    <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above"
                                        (click)="removeDetailx(i)">
                                    <i class="material-symbols-outlined text-danger">
                                        delete
                                    </i>
                                </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="text-right mt-3">
              <button mat-raised-button color="primary" type="submit">Créer le Devis</button>
            </div>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
</ng-template>

<!-- modal template for editing -->
<ng-template #editModal let-modal>
  <mat-card class="daxa-card border-radius bg-white border-none d-block">
      <mat-card-header>
          <mat-card-title>
              <h5 class="mt-0 mb-0">Modifier Devis</h5>
          </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form [formGroup]="form" (ngSubmit)="saveUpdatedDevis()">
          <div class="row g-3">

              <div class="col-sm-6">
                  <mat-form-field class="full-width">
                      <mat-label>Client</mat-label>
                      <mat-select formControlName="clientId">
                          <mat-option *ngFor="let client of clients" [value]="client.id">
                              {{ client.socialReason }}
                          </mat-option>
                      </mat-select>
                      <mat-error *ngIf="form.get('clientId')?.hasError('required')">Le client est requis</mat-error>
                  </mat-form-field>
              </div>

              <div class="col-sm-6" *ngFor="let field of ['dateCreation', 'dateExpiration', 'dateLivraison']">
                  <mat-form-field class="full-width">
                      <mat-label>
                          {{ field === 'dateCreation' ? 'Date de création' : 
                             field === 'dateExpiration' ? 'Date d\'expiration' : 
                             field === 'dateLivraison' ? 'Date de livraison' : field }}
                      </mat-label>
                      <input matInput type="date" [formControlName]="field">
                      <mat-error *ngIf="form.get(field)?.hasError('required')">Ce champ est requis</mat-error>
                  </mat-form-field>
              </div>
          
              <div class="col-sm-6">
                  <mat-form-field class="full-width">
                      <mat-label>Délai de livraison après commande</mat-label>
                      <input matInput type="number" formControlName="delaiLivraison" min="1">
                      <mat-error *ngIf="form.get('delaiLivraison')?.hasError('required')">Ce champ est requis</mat-error>
                  </mat-form-field>
              </div>
              <div class="col-sm-6">
                <mat-form-field class="full-width">
                    <mat-label>Durée de validité</mat-label>
                    <input matInput formControlName="validite" placeholder="Ex. 30 jours">
                    <mat-error *ngIf="form.get('validite')?.hasError('required')">La durée de validité est requise</mat-error>
                </mat-form-field>
            </div>
          
              <div class="col-sm-6" *ngFor="let field of ['methodeExpedition', 'conditionReglement']">
                  <mat-form-field class="full-width">
                      <mat-label>{{ field === 'methodeExpedition' ? 'Méthode d\'expédition' : 'Condition de règlement' }}</mat-label>
                      <textarea matInput [formControlName]="field" rows="4"></textarea>
                      <mat-error *ngIf="form.get(field)?.hasError('required')">Ce champ est requis</mat-error>
                  </mat-form-field>
              </div>
          

              <div class="col-sm-6">
              <mat-form-field *ngIf="devis && devis.status === 'ENVOYE'" class="full-width">
                <mat-label>Référence client</mat-label>
                <input matInput formControlName="clientReference" placeholder="Saisir la référence client" />
              </mat-form-field>
            </div>

          
            <div class="col-sm-6" [ngStyle]="{ display: 'none' }">
              <mat-form-field class="full-width">
                  <mat-label>Statut</mat-label>
                  <mat-select formControlName="status" placeholder="Sélectionnez un statut">
                      <mat-option *ngFor="let statut of statutsDevis" [value]="statut">
                          {{ statut }}
                      </mat-option>
                  </mat-select>
                  <mat-error *ngIf="form.get('status')?.hasError('required')">Le statut est requis</mat-error>
              </mat-form-field>
          </div>
               <div [formGroup]="detailForm" class="row g-3">
  <div class="d-flex align-items-center g-3">
    <div class="col-sm-4">
      <mat-form-field class="full-width">
        <mat-label>Type d'Analyse</mat-label>
        <mat-select formControlName="typeAnalyseId" (selectionChange)="onTypeAnalyseChangex()">
          <mat-option *ngFor="let typeAnalyse of typeAnalyses" [value]="typeAnalyse.id">
            {{ typeAnalyse.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="detailForm.get('typeAnalyseId')?.hasError('required')">Requis</mat-error>
      </mat-form-field>
    </div>

    <div class="col-sm-4 ms-3">
      <mat-form-field class="full-width">
        <mat-label>Quantité</mat-label>
        <input matInput type="number" formControlName="qte" min="1">
        <mat-error *ngIf="detailForm.get('qte')?.hasError('required')">Requis</mat-error>
      </mat-form-field>
    </div>

    <div class="col-sm-3 ms-3">
      <mat-form-field class="full-width">
        <mat-label>Prix Unitaire</mat-label>
        <input matInput type="number" formControlName="prixUnitaire" readonly>
        <mat-error *ngIf="detailForm.get('prixUnitaire')?.hasError('required')">Requis</mat-error>
      </mat-form-field>
    </div>

    <div class="col-sm-1 d-flex align-items-center ms-1">
      <button type="button" mat-button matTooltip="Modifier" matTooltipPosition="above" (click)="addDetailf()">
        <i class="material-symbols-outlined text-primary" style="font-size: 30px;">
          add
        </i>
      </button>
    </div>
  </div>
              </div>

              <table class="table table-striped table-bordered mt-4" *ngIf="detailsArray.length > 0">
                <thead class="table-light">
                  <tr>
                  <th>Type d'Analyse</th>
                  <th>Méthode</th>
                  <th>Délai</th>
                   <th>Prix Unitaire</th>
                  <th>Quantité</th>
                  <th><strong>Total</strong></th> 
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let d of detailsList; let i = index">
                  <td>{{ getTypeAnalyseName(d.typeAnalyseId) }}</td>
                  <td>{{ getTypeAnalyseDesc(d.typeAnalyseId) }}</td>
                  <td>{{ getTypeAnalyseDelai(d.typeAnalyseId) }}j</td>
                  <td>{{ d.prixUnitaire }}</td>
                  <td>{{ d.qte }}</td>
                  <td>{{ d.total }}</td>

                  <td>
                      <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above" (click)="removeDetailF(i)">
                        <i class="material-symbols-outlined text-danger">delete</i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>    
            <div class="d-flex justify-content-center">
              <mat-checkbox
              [checked]="!form.get('tvaApplicable')?.value"
              (change)="form.get('tvaApplicable')?.setValue(!$event.checked)">
                TVA Non Applicable  
              </mat-checkbox>
            </div>    
              <div class="text-right mt-3">
                <!--<button *ngIf="devis && devis.status === 'BROUILLON'" class="btn btn-primary">Passer en Cours</button>-->
                <button *ngIf="devis && devis.status === 'BROUILLON'" (click)="validerDevis(devis.id)"  class="btn btn-primary">Passer en Valide</button>
                <button *ngIf="devis && devis.status === 'VALIDE'" (click)="envoyerDevis(devis.id)"  class="btn btn-primary">Envoyer au Client</button>
                <button *ngIf="devis && devis.status === 'VALIDE'" 
                (click)="modifierDevis(devis.id, 'MODIFIER')" class="btn btn-secondary" style="margin-left: 10px;">Modifier</button>
                <button *ngIf="devis && devis.status === 'ENVOYE'" (click)="accepterDevis(devis.id, form.get('clientReference')?.value)" class="btn btn-primary" style="margin-right: 14px;"> Accepter </button>
                <button *ngIf="devis && devis.status === 'ENVOYE'" type="button" (click)="rejeterDevis(devis.id)" class="btn btn-danger">Rejeter</button>
              </div>

              
          </div>
      </form>
      </mat-card-content> 
  </mat-card>
</ng-template>
<mat-menu #menu="matMenu">
    <div class="scrollable-menu shadow-lg bg-body">
        <mat-checkbox [checked]="displayedColumns.length == columns.length" (change)=" handleIsAllColsSelected($event)"
                      (click)="$event.stopPropagation()">Tous
        </mat-checkbox>
        @for (col of columns; track $index) {
            <div>
                <mat-checkbox [value]="col"
                              [checked]="displayedColumns.includes(col) || displayedColumns.length == columns.length"
                              (click)="$event.stopPropagation(); onSelectionChange(col)">
                    {{ col }}
                </mat-checkbox>
            </div>
        }
    </div>

</mat-menu>



